import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Spinner,
  Stat,
  StatArrow,
  StatGroup,
  StatHelpText,
  StatLabel,
  StatNumber,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { collection, getDocs } from "firebase/firestore";
import React, { useState, useMemo } from "react";
import { db } from "../../firebase-config";
import MapCarrosFiliais from "../../components/MapCarrosFiliais";
import _ from "lodash";
import {
  ArrowUpIcon,
  DeleteIcon,
  DownloadIcon,
  SearchIcon,
} from "@chakra-ui/icons";
import { useCallback } from "react";
import "./styles.css";

const Carros = () => {
  const [donwloadDados, setdonwloadDados] = useState(false);
  const [dados, setDados] = useState([]);
  const [searchTerm, setSearchTerm] = useState(""); // estado para armazenar o termo de pesquisa
  const [loading, setLoading] = useState(false);
  const [carcount, SetcarCount] = useState(0);

  const colecoes = [
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/BARRA GRANDE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/BOIPEBA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/GAMBOA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/VALENÇA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/CAIRU",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/CRUZEIRO DE LAJE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/GANDU",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/CAMAMU",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/JIQUIRIÇÁ",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/LAJE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/MARAÚ",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/MUTUÍPE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/ITAMARATY",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/PALMA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/NILO PEÇANHA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/UBAÍRA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/TEOLÂNDIA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/WENCESLAU",
  ];

  const getDados = useCallback(async () => {
    setLoading(true);
    setdonwloadDados(true);
    const promises = colecoes.map(async (colecao) => {
      const collectionRef = collection(db, colecao);
      const snapshot = await getDocs(collectionRef);

      return snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        colecao,
      }));
    });

    const dados = await Promise.all(promises);
    setDados(dados.flat());
    setLoading(false);
  }, []);

  // useMemo para melhorar o desempenho
  const filteredData = useMemo(() => {
    return dados.filter(
      (carro) =>
        carro.Carro.filial.toLowerCase().includes(searchTerm.toLowerCase()) ||
        carro.Carro.placa.toLowerCase().includes(searchTerm.toLowerCase()) ||
        carro.Carro.modelo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        carro.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        carro.Carro.status.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [dados, searchTerm]);

  const groupedData = useMemo(() => {
    return _.groupBy(filteredData, "Carro.filial");
  }, [filteredData]);

  function Subir() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  // Total
  const getTotalCars = () => {
    return dados.filter((car) => car.Carro && car.Carro.filial !== "Teste")
      .length;
  };

  const totalCars = useMemo(() => getTotalCars(), [dados]);

  // Ativos
  const getActiveCars = () => {
    return dados.filter(
      (car) => car.Carro.status === "Ativo" && car.Carro.filial !== "Teste"
    ).length;
  };

  const activeCars = useMemo(() => getActiveCars(), [dados]);

  // Inativos
  const getInactiveCarsCars = () => {
    return dados.filter(
      (car) => car.Carro.status === "Inativo" && car.Carro.filial !== "Teste"
    ).length;
  };

  const inactiveCars = useMemo(() => getInactiveCarsCars(), [dados]);

  // Manutenção
  const getMaintenanceCarsCars = () => {
    return dados.filter(
      (car) => car.Carro.status === "Manutenção" && car.Carro.filial !== "Teste"
    ).length;
  };

  const maintenanceCars = useMemo(() => getMaintenanceCarsCars(), [dados]);

  return (
    <>
      {!donwloadDados ? (
        <Button
          onClick={getDados}
          width="full"
          mb={3}
          colorScheme="green"
          leftIcon={<DownloadIcon />}
        >
          CARREGAR TODOS OS CARROS
        </Button>
      ) : (
        <InputGroup mb={3} mt={3}>
          <InputLeftElement
            pointerEvents="none"
            children={<SearchIcon color="gray.300" />}
          />
          <Input
            type="text"
            placeholder="Pesquise por Filial, Status, Placa ou Modelo do carro, Ex: Strada"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <Tooltip
            hasArrow
            label="Limpar Pesquisa"
            bg="red.500"
            placement="left"
          >
            <IconButton
              colorScheme="red"
              aria-label="Limpar Campos"
              icon={<DeleteIcon />}
              onClick={() => setSearchTerm("")}
            />
          </Tooltip>
        </InputGroup>
      )}

      {loading === true ? (
        <Flex justifyContent="center" mt="15%">
          <Spinner
            thickness="8px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            width={100}
            height={100}
          />
        </Flex>
      ) : null}
      <Box>
        {dados < 1 ? null : (
          <Card size="sm">
            <CardBody>
              <StatGroup
                alignContent={"center"}
                alignItems={"center"}
                textAlign="center"
              >
                <Stat>
                  <Tag
                    size={"lg"}
                    borderRadius="full"
                    variant="solid"
                    colorScheme="gray"
                  >
                    <TagLabel>Total</TagLabel>
                  </Tag>
                  <StatNumber alignContent={"center"}>{totalCars}</StatNumber>
                </Stat>

                <Stat>
                  <Tag
                    size={"lg"}
                    borderRadius="full"
                    variant="solid"
                    colorScheme="green"
                  >
                    <TagLabel>Ativos</TagLabel>
                  </Tag>
                  <StatNumber>{activeCars}</StatNumber>
                </Stat>

                <Stat>
                  <Tag
                    size={"lg"}
                    borderRadius="full"
                    variant="solid"
                    colorScheme="yellow"
                  >
                    <TagLabel>Manutenção</TagLabel>
                  </Tag>
                  <StatNumber>{maintenanceCars}</StatNumber>
                </Stat>

                <Stat>
                  <Tag
                    size={"lg"}
                    borderRadius="full"
                    variant="solid"
                    colorScheme="red"
                  >
                    <TagLabel>Inativos</TagLabel>
                  </Tag>
                  <StatNumber>{inactiveCars}</StatNumber>
                </Stat>
              </StatGroup>
            </CardBody>
          </Card>
        )}

        {Object.keys(groupedData).map((filial) => (
          <div key={filial}>
            <Card
              key={filial}
              width="100%"
              mb={5}
              mt={5}
              bgGradient="linear(to-r, blue.500, green.500)"
              boxShadow="md"
            >
              <CardHeader textAlign="center">
                <Text fontSize="xl" color="white" as="b">
                  {filial}
                </Text>
              </CardHeader>
            </Card>
            <SimpleGrid
              spacing={5}
              templateColumns="repeat(auto-fill, minmax(300px, 1fr))"
            >
              {groupedData[filial].map((carro) => (
                <MapCarrosFiliais key={carro.id} carro={carro} />
              ))}
            </SimpleGrid>
          </div>
        ))}
        <Button
          onClick={Subir}
          id="myBtn"
          title="Ir ao topo"
          bgGradient="linear(to-r, blue.500, green.500)"
          _hover={{
            bgGradient: "linear(to-l, blue.500, green.500)",
          }}
          leftIcon={<ArrowUpIcon />}
        >
          Topo
        </Button>
      </Box>
    </>
  );
};

export default Carros;
